import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import isEqual from 'lodash/isEqual'
import cn from 'classnames'
import ListFromTable from 'components/common/ListFromTable'
import {
  fetchProjectedSitesManagerSingleItem,
  setPsfs,
} from 'reducers/projectedSitesManager/reducer'
import Psfs from 'lib/psfs/Psfs'
import {
  FRESHWATER_CLIENT_FEILDS,
  SEAWATER_SITE_FIELDS,
} from 'constants/projectedSitesManager'
import Sort from 'lib/psfs/Sort'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import UrlHelper from 'helpers/url'
import * as ROUTE from 'constants/appRouting'
import { SITE_TYPE_SEAWATER } from 'constants/index'
import ProfileHelper from 'helpers/profile'
import messages from '../translate'

class SingleItemTable extends ListFromTable {
  constructor(props) {
    super(props)
    this.asyncData = true
    this.loadingData = true
    this.state = {
      ...this.state,
    }
    const { tableRef } = props
    this.tableRef = tableRef

    this.init()
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const {
      storePsfs,
      tableData,
      history,
      siteId,
      snapshot,
      siteType,
      specieId,
      year,
    } = this.props
    const {
      storePsfs: nextPsfs,
      tableData: nextTableData,
      isLoadTable,
    } = nextProps

    this.loadingData = isLoadTable

    if (!isEqual(tableData, nextTableData)) {
      this.loadingData = false
    }

    if (storePsfs !== nextPsfs) {
      const route =
        siteType === SITE_TYPE_SEAWATER
          ? ROUTE.PROJECTED_SITES_MANAGER_SEAWATER_SITE
          : ROUTE.PROJECTED_SITES_MANAGER_FRESHWATER_CLIENT
      const path = UrlHelper.create(route, {
        id: siteId,
        snapshot,
        type: siteType,
        specie: specieId,
        year,
      })

      history.replace(`${path}${nextPsfs.criteriaPath}`)
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  componentDidUpdate(prevProps) {
    const {
      storePsfs: newStorePsfs,
      fetchProjectedSitesManagerSingleItem,
      siteType,
      snapshot,
      siteId,
      specieId,
      year,
      setActiveItem,
      tableData,
      isLoadTable,
    } = this.props
    const { storePsfs: prevStorePsfs, tableData: nextTableData } = prevProps

    this.loadingData = isLoadTable

    if (!isEqual(tableData, nextTableData)) {
      const { data } = tableData

      if (data && data.length) {
        const [item] = data
        const { client, site, specie } = item

        setActiveItem(client, site, specie, year)
      } else {
        setActiveItem('')
      }
    }

    if (prevStorePsfs !== newStorePsfs) {
      fetchProjectedSitesManagerSingleItem({
        psfs: newStorePsfs,
        siteType,
        snapshot,
        siteId,
        specieId,
        year,
      })
    }
  }

  init = () => {
    const { setPsfs, tableData, setActiveItem, year } = this.props
    const { data } = tableData

    this.historyPush = path => {
      this.setState({ pathname: path })
      setPsfs(new Psfs(path))
    }

    if (data && data.length) {
      const [item] = data
      const { client, site, specie } = item

      setActiveItem(client, site, specie, year)
    }

    setPsfs(this.psfs)
  }

  getTableProps() {
    const { tableData, onEditData, storePsfs, snapshot } = this.props
    const tableDataLength =
      Object.prototype.hasOwnProperty.call(tableData, 'count') &&
      tableData.count
    const isSnapshot = snapshot !== 'main-table'

    return {
      title: '',
      className: cn({
        'is-editable': true,
        'projected-sites-manager-table': true,
        'vertical-scroll': tableDataLength > 10,
        snapshot: isSnapshot,
      }),
      showFilterBar: false,
      sorting: true,
      paging: true,
      hasStorePsfs: true,
      stickyHeader: true,
      storePsfs,
      onRowClick: row => onEditData(row),
    }
  }

  getColumns() {
    const {
      storePsfs,
      intl: { formatMessage },
      siteType,
    } = this.props
    const {
      _field,
      _order: [orderType],
    } = storePsfs.sortObj
    const tableFields =
      siteType === SITE_TYPE_SEAWATER
        ? SEAWATER_SITE_FIELDS.sort((a, b) => a.id - b.id)
        : FRESHWATER_CLIENT_FEILDS.sort((a, b) => a.id - b.id)

    const getSorting = storeName => {
      const sorting = {}

      if (_field && _field === storeName) {
        sorting.defaultSort = _field
        sorting.defaultSortOrder = Sort[orderType.toUpperCase()]
      }

      return sorting
    }

    const columns = new ColumnCollection()

    columns.add(
      new Column('id', 'ID', {
        sorting: true,
        cellClassName: 'logbook-event-arrow-cell',
        render: rowData => rowData.id || rowData.clientId,
      }),
    )

    tableFields.forEach(({ storeName, translateName }) => {
      const sortParams = getSorting(storeName)

      columns.add(
        new Column(
          storeName,
          formatMessage(messages[translateName]),
          {
            sorting: true,
            ...sortParams,
            render: rowData => {
              let message = rowData[storeName]

              if (message && typeof message === 'number') {
                const { code: currentCode } = ProfileHelper.getCurrentLocale()

                message = message.toLocaleString(
                  currentCode === 'es' ? `${currentCode}-CL` : currentCode,
                )
              }

              return Array.isArray(message)
                ? message.map(item => formatMessage({ id: item })).join(', ')
                : message
            },
          },
          true,
        ),
      )
    })

    return columns
  }
}

export default connect(
  state => ({
    isLoadTable: state.getIn(['projectedSitesManager', 'isLoadTable']),
    storePsfs: state.getIn(['projectedSitesManager', 'storePsfs']),
  }),
  {
    setPsfs,
    fetchProjectedSitesManagerSingleItem,
  },
)(injectIntl(SingleItemTable))
